import { render, staticRenderFns } from "./GradeSetting.vue?vue&type=template&id=8139a2e4&scoped=true&"
import script from "./GradeSetting.vue?vue&type=script&lang=js&"
export * from "./GradeSetting.vue?vue&type=script&lang=js&"
import style0 from "./GradeSetting.vue?vue&type=style&index=0&id=8139a2e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8139a2e4",
  null
  
)

export default component.exports